import { useTheme } from 'styled-components'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'
import Reason from '@/metrics/components/Reason/Reason'
import { getReasonColors } from '@/metrics/helpers/helpers'

import ReasonsListSkeleton from './ReasonsListSkeleton/ReasonsListSkeleton'
import * as Styles from './styles'

const ReasonsList = ({ reasons = [], loading, onClickReason, reasonType }) => {
  const theme = useTheme()
  const getOnClickHandler = (onClick, index, reasonType) => {
    if (typeof onClick === 'function') {
      return () => onClick(index, reasonType)
    }
  }

  if (loading) return <ReasonsListSkeleton />
  if (!reasons?.length) return <NoResultsFound />

  return (
    <Styles.MainContainer>
      <Styles.ReasonsContainer>
        {reasons?.map((reason, index) => (
          <Reason
            key={index}
            index={Number(index + 1)}
            reason={reason}
            barColor={getReasonColors(theme)?.[reasonType]?.bar}
            textBarColor={getReasonColors(theme)?.[reasonType]?.text}
            onClick={getOnClickHandler(onClickReason, index, reasonType)}
          />
        ))}
      </Styles.ReasonsContainer>
    </Styles.MainContainer>
  )
}

export default ReasonsList
